import isEmpty from 'lodash/isEmpty';
import { useState } from 'react';
import { BannerSliderEvents } from 'shared/constants/datalayer';
import { CypressVariables } from 'shared/cypress';
import { BannerData } from 'shared/types/cms';
import { isMobile } from 'shared/util/utility';
import { Swiper, SwiperSlide } from 'swiper/react';
import { bannerSwiperConfig } from '../Banner.utils';
import { BannerItem } from './BannerItem';
import { LoaderSlider } from './LoaderSlider';
export const BannerSlider = ({ banner }: { banner: BannerData[] }) => {
	const [swiperReady, setSwiperReady] = useState(false);
	const handleBannerClick = (banner: BannerData, index: number) => {
		BannerSliderEvents.HOME_PAGE_BANNER_CLICK({ hp_banner_image_alt: banner.imageAltText, hp_banner_position: [index] });
	};

	const sliderTemplate = banner.map((banner: BannerData, index: number) => {
		const link = isMobile() && banner.altLink ? banner.altLink : banner.link;
		const alt = banner.imageAltText || banner.title;
		return (
			<SwiperSlide key={`bannerData-${banner.subBannerId}`}>
				<BannerItem link={link} alt={alt} timed={banner.isTimed} image={banner.imageUrl} onClick={() => handleBannerClick(banner, index)} />
			</SwiperSlide>
		);
	});

	return (
		<div className="relative">
			<LoaderSlider className={'absolute top-0 left-0 inset-0'} visible={!banner?.length || !swiperReady} />
			<section className="styled-banner-slider" data-cy={CypressVariables.Banners}>
				{banner && !isEmpty(banner) && (
					<Swiper onSwiper={() => setTimeout(() => setSwiperReady(true), 100)} {...bannerSwiperConfig(banner.length)} navigation={true}>
						{sliderTemplate}
					</Swiper>
				)}
			</section>
		</div>
	);
};
